module.exports = __webpack_public_path__ + "img/blitz_left.f877370d.jpg";